export enum ProgramType {
    LSLR = 1,
    LCR,
    CR,
    LIS,
    PF,
    COVID,
    VERIFICATION
}